/* Minimal EN/ES i18n. Wrap app in LanguageProvider; use useT() to get a translate function. */
import React, { createContext, useContext, useEffect, useState } from "react";

const LANG_KEY = "aabb_lang_v2"; // v2: Spanish as default
export const LanguageContext = createContext({ lang: "es", setLang: () => {} });

const DICT = {
  // Nav
  "nav.home":         { en: "Home",          es: "Inicio" },
  "nav.tirzepatide":  { en: "Tirzepatide",   es: "Tirzepatida" },
  "nav.how":          { en: "How It Works",  es: "Cómo Funciona" },
  "nav.guides":       { en: "Free Guides",   es: "Guías Gratuitas" },
  "nav.contact":      { en: "Contact",       es: "Contacto" },
  "nav.shop":         { en: "Shop",          es: "Tienda" },
  // Hero (home)
  "hero.eyebrow":     { en: "Medical Weight Loss · Miami", es: "Pérdida de Peso Médica · Miami" },
  "hero.h1.html":     { en: "Finally Lose Weight, Feel <em>in Control</em> &amp; Get Your Energy Back",
                        es: "Baja de peso, controla tu cuerpo y vuelve a <em>sentirte tú</em>" },
  "hero.sub":         { en: "Medically guided programs designed to fix your metabolism, control cravings, and deliver real, sustainable results.",
                        es: "Programas médicos diseñados para ayudarte a perder peso, controlar la ansiedad por la comida y recuperar tu energía—con acompañamiento profesional." },
  "hero.cta":         { en: "Check Your Eligibility", es: "Ver si califico" },
  "hero.trust.1":     { en: "Medical supervision included", es: "Supervisión médica incluida" },
  "hero.trust.2":     { en: "Personalized protocol",        es: "Plan personalizado" },
  "hero.trust.3":     { en: "Fast approval",                es: "Evaluación rápida" },
  "hero.trust.4":     { en: "Delivered to your door",       es: "Entrega directa a tu casa" },
  // CTAs
  "cta.start_program":  { en: "Start My Program",       es: "Quiero empezar mi plan" },
  "cta.add_to_plan":    { en: "Add to my plan",         es: "Agregar a mi plan" },
  "cta.optimize_plan":  { en: "Optimize my plan",       es: "Optimizar mi plan" },
  "cta.boost":          { en: "Boost My Results →",     es: "Potencia Mis Resultados →" },
  "cta.optimize_body":  { en: "Optimize My Body →",     es: "Optimiza Mi Cuerpo →" },
  "cta.start_advanced": { en: "Start Advanced Program →", es: "Iniciar Programa Avanzado →" },
  "cta.get_started":     { en: "Get Started Now",       es: "Comienza ahora" },
  "cta.free_guide":     { en: "Free Guide ↓",           es: "Guía Gratis ↓" },
  "cta.check_my_price":  { en: "Check My Price",        es: "Ver precio en mi estado" },
  "cta.check_eligibility":{ en: "Check My Eligibility →", es: "Verificar Mi Elegibilidad →" },
  // Section labels
  "label.most_popular_program":   { en: "Our Most Popular Program", es: "Nuestro Programa Más Efectivo" },
  "label.most_popular_badge":     { en: "Most Popular",             es: "Más Popular" },
  "label.anti_aging_support":     { en: "Anti-Aging Support",       es: "Soporte Anti-Aging" },
  "label.cellular":               { en: "Cellular Anti-Aging",      es: "Anti-Aging Celular" },
  "label.hormone":                { en: "Hormone Optimization",     es: "Optimización Hormonal" },
  "label.if_this_sounds":         { en: "If This Sounds Like You…", es: "Si Te Identificas…" },
  "label.solution":               { en: "The Solution",             es: "La Solución" },
  "label.authority":              { en: "Authority · Why It Works", es: "Autoridad · Por Qué Funciona" },
  "label.how_it_works":           { en: "How It Works",             es: "Cómo Funciona" },
  "label.pricing":                { en: "Pricing",                  es: "Precio" },
  "label.trust":                  { en: "Trust",                    es: "Confianza" },
  "label.free_resources":         { en: "Free Resources",           es: "Recursos Gratuitos" },
  "label.client_experiences":     { en: "Client Experiences",       es: "Experiencias de Clientes" },
  "label.starting_at":            { en: "Starting at",              es: "Desde" },
  "label.in_clinic":              { en: "In-Clinic · Miami, FL",    es: "En Clínica · Miami, FL" },
  "label.guided_program":         { en: "Guided Program Selection · Miami, FL · Nationwide Shipping",
                                    es: "Selección de Programa Guiada · Miami, FL · Envío Nacional" },
  // Misc
  "common.cart":                  { en: "Cart",                     es: "Carrito" },
  "common.continue":              { en: "Continue",                 es: "Continuar" },
  "common.add_to_cart":           { en: "Add to cart",              es: "Agregar al carrito" },
  "common.checkout":              { en: "Checkout",                 es: "Pagar" },
  "common.total":                 { en: "Total",                    es: "Total" },
  // Check My Price Modal
  "modal.where_located":          { en: "Where are you located at?", es: "¿Dónde te encuentras?" },
  "modal.state_determines":       { en: "Your state determines pricing, available programs, and shipping. All 50 states served.",
                                    es: "Tu estado determina el precio, los programas disponibles y el envío. Servimos los 50 estados." },
  "modal.select_state":           { en: "Select your state…",       es: "Selecciona tu estado…" },
  "modal.pricing_in":             { en: "Pricing in",               es: "Precios en" },
  "modal.your_pricing":           { en: "Your personalized pricing", es: "Tu precio personalizado" },
  "modal.change_state":           { en: "Change state",             es: "Cambiar estado" },
  "modal.programs":               { en: "Programs",                 es: "Programas" },
  "modal.most_popular":           { en: "⭐ Most popular",           es: "⭐ Más popular" },
  "modal.maximum":                { en: "Maximum",                  es: "Máximo" },
  "modal.add_to_plan":            { en: "Add to my plan",           es: "Agregar a mi plan" },
  "modal.individual_products":    { en: "Individual Products",      es: "Productos Individuales" },
  "modal.buy_individually":       { en: "Purchase any product individually — no program required.",
                                    es: "Compra cualquier producto individualmente — no se requiere programa." },
  "modal.add_to_cart":            { en: "Add to cart",              es: "Agregar al carrito" },
  "modal.membership_note":        { en: "3-month minimum for membership pricing. Prices vary by state.",
                                    es: "Mínimo 3 meses para precio de membresía. Los precios varían por estado." },
};

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem(LANG_KEY) || "es");
  useEffect(() => { localStorage.setItem(LANG_KEY, lang); document.documentElement.lang = lang; }, [lang]);
  return <LanguageContext.Provider value={{ lang, setLang }}>{children}</LanguageContext.Provider>;
}

export function useLang() { return useContext(LanguageContext); }

export function useT() {
  const { lang } = useLang();
  return (key, fallback = "") => {
    const e = DICT[key];
    if (!e) return fallback || key;
    return e[lang] || e.en || fallback || key;
  };
}

export function LangToggle() {
  const { lang, setLang } = useLang();
  return (
    <div className="hp-lang-wrap" data-testid="lang-toggle">
      <button
        onClick={() => setLang("en")}
        className={`hp-lang ${lang === "en" ? "" : "muted"}`}
        style={{background:"none", border:"none", cursor:"pointer", padding:"4px 6px", fontFamily:"inherit", fontSize:".85rem", letterSpacing:".12em"}}
        data-testid="lang-en"
      >EN</button>
      <span className="hp-lang-divider">|</span>
      <button
        onClick={() => setLang("es")}
        className={`hp-lang ${lang === "es" ? "" : "muted"}`}
        style={{background:"none", border:"none", cursor:"pointer", padding:"4px 6px", fontFamily:"inherit", fontSize:".85rem", letterSpacing:".12em"}}
        data-testid="lang-es"
      >ES</button>
    </div>
  );
}
